import React from "react";

export default function HostConfig() {
    return (
        <div>
            ここにメールの文面などホストが設定する情報の画面
        </div>
    )
}